// ABOUTME: Shared fetch for POST /agent/speech (ElevenLabs TTS) — used by the
// chat speaker/play controls (useChatSpeech) and the Settings voice-preview
// button (AgentVoiceCard), so both honor the same business-id header and
// voice_id contract.

import { fetchWithAuthRetry, getBaseUrl } from '@/api/client'
import { useAuthStore } from '@/stores/useAuthStore'

/** POST /agent/speech and return the raw streaming Response. Callers read
 *  `.body` for progressive playback or `.blob()` for a short preview clip. */
export async function fetchAgentSpeech(
  text: string,
  voiceId: string | undefined,
  signal: AbortSignal
): Promise<Response> {
  const baseUrl = getBaseUrl()
  const user = useAuthStore.getState().user
  const businessId = (user as Record<string, unknown> | null)?.default_business_id as
    | string
    | undefined

  const response = await fetchWithAuthRetry((token) => {
    const headers: Record<string, string> = { 'Content-Type': 'application/json' }
    if (token) headers['Authorization'] = `Bearer ${token}`
    if (businessId) headers['X-Business-ID'] = businessId
    return fetch(`${baseUrl}/agent/speech`, {
      method: 'POST',
      headers,
      body: JSON.stringify(voiceId ? { text, voice_id: voiceId } : { text }),
      signal,
    })
  }, signal)

  if (!response.ok || !response.body) {
    throw new Error(`Spoken reply request failed (${response.status})`)
  }
  return response
}
